/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React from 'react';
import { Link } from 'react-router-dom';

function OrderPlacedModal({ OrderDetails }) {
    return (
        <div className="modal fade fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto orderPlaced " id="orderPlaced" tabIndex="-1" aria-labelledby="orderPlaced" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative lg:max-w-[400px] lg:min-w-[400px] w-full px-3 pointer-events-none" style={{ margin: 'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col pointer-events-auto w-full bg-white bg-clip-padding rounded-md outline-none text-current px-3 sm:pt-[32px] pt-4 pb-5">
                    <div className="modal-header flex flex-shrink-0 items-center justify-center rounded-t-md relative">
                        <h5 className="sm:text-xl text-lg font-semibold leading-normal text-[#090406]" id="exampleModalScrollableLabel">
                            Order Placed Successfully!
                        </h5>
                    </div>
                    <div className="modal-body sm:pt-6 pt-5">
                        <img src="/images/success-filled.svg" alt="icon" className="mx-auto" />
                        <p className="text-center font-normal text-xs6 text-[#090406] mt-5">
                            Thank you, your order is under review.
                            Once Accepted/Rejected you will be notified in your email.
                        </p>
                        <p className="sm:pt-3 pt-4 sm:text-xl text-lg font-semibold leading-normal text-[#090406] text-center">
                            Order Number:
                            {' '}
                            {OrderDetails.order_initial_number}
                        </p>
                        <div className="pt-3.5 w-full">
                            <Link to="/manage-orders" className="w-full flex justify-center">
                                <button type="button" className="w-full sm:w-[306px] sm:py-3.5 py-2 rounded-lg bg-[#555259] sm:text-lg text-base font-semibold text-[#FFFFFF]" data-bs-dismiss="modal" aria-label="Close">
                                    Go to Manage Orders
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default OrderPlacedModal;
